import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

/**
 * Fetch a short-lived signed PDF URL for the given transport and open it in a
 * new tab. Works on mobile Safari/Chrome without cookies because the resulting
 * URL is a path-segment token endpoint (/api/pdf/<jwt>).
 */
export async function openTransportPdf(transportId, opts = {}) {
  // Open a blank tab synchronously (so it counts as a user gesture and avoids
  // popup blockers on iOS Safari), then navigate it once we have the URL.
  const win = opts.newTab === false ? null : window.open("about:blank", "_blank");
  try {
    const { data } = await api.post(`/transports/${transportId}/pdf-link`);
    const url = data.pdf_url;
    if (win) {
      win.location.href = url;
    } else {
      window.location.href = url;
    }
    return url;
  } catch (e) {
    if (win) win.close();
    toast.error(formatApiError(e.response?.data?.detail) || "Impossible d'ouvrir le PDF");
    return null;
  }
}
